import { render, staticRenderFns } from "./AdminProductEdit.vue?vue&type=template&id=623e38f1&scoped=true"
import script from "./AdminProductEdit.vue?vue&type=script&lang=js"
export * from "./AdminProductEdit.vue?vue&type=script&lang=js"
import style0 from "./AdminProductEdit.vue?vue&type=style&index=0&id=623e38f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623e38f1",
  null
  
)

export default component.exports
import {QSkeleton} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSkeleton})
